import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MembershipsCards from '../MembershipsCards/index';
import Features from './Features';
import History from './History';
import Payment from './Payment';
import Billing from './Billing';
import MembershipIcon from '../Icons/MembershipIcon';
import PayIcon from '../Icons/PayIcon';
import BillingIcon from '../Icons/BillingIcon';
import HistoryIcon from '../Icons/HistoryIcon';
import NoMembership from './NoMembership';
import { useRouteMatch, useHistory } from 'react-router-dom';

import * as ROUTES from '../../routes';
import { getMembershipData } from '../../store/actions/UserAction';
import ScrollToTopOnMount from '../ScrollToTopOnMount';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box
        p={5}
        padding={value === 1 ? '40px 0' : '40px 24px'}
        maxWidth="960px"
      >
        {children}
      </Box>
    </Typography>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: 'white',
    height: 75,
    borderRadius: 4,
    margin: 'auto',
    boxShadow: 'unset',
  },
  root: {
    //flexGrow: 1,
    backgroundColor: '#f6f8fb',
    maxWidth: 960,
    //margin: 'auto',
    marginBottom: 20,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  tabStyle: {
    width: 224,
    height: 66,
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    '&$selected': {
      color: '#013957',
    },
    '@media screen and (max-width: 549px)': {
      // minWidth: '100%',
      width: 140
    },
  },
  tabStyleDisabled: {
    width: 224,
    height: 66,
    fontSize: 16,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    textTransform: 'none',
    borderBottom: '1px solid #e7e7e7',
    '&$selected': {
      color: '#013957',
    },
    '&$disabled': {
      cursor: 'not-allowed',
    },
    '@media screen and (max-width: 549px)': {
      minWidth: '100%',
    },
  },
  selected: {},
  textColorPrimary: {
    color: '#c1c1c1',
  },
  tabs: {
    padding: '0 24px',
    '@media (max-width: 1280px)': {
      padding: 0,
    },
  },
  indicator: {
    height: 2,
    backgroundColor: '#013957',
  },
  tabsContainer: {
    //width: 'fit-content',
    margin: 'auto',
  },
  scrollButtonsDesktop: {
    color: '#013957',
    display: 'none',
    '@media (max-width: 1280px)': {
      display: 'inherit',
    },
    '&>svg': {
      fontSize: 24,
    },
  },
  panel: {
    position: 'relative',
    maxWidth: 960,
    backgroundColor: '#ffffff',
  },
  tabWrapper: {
    display: 'contents',
  },
}));


 function MyMembership(props) {
  const {value, handleChange, membershipData, getMembershipData, membershipType, role, billingData, suscription, gift300, idLawFirm } = props;
  const classes = useStyles();
  const history = useHistory();
  const paymentRoute = useRouteMatch(ROUTES.MEMBERSHIP_PAYMETHOD);
  const historyRoute = useRouteMatch(ROUTES.MEMBERSHIP_HISTORY);
  const invoicesRoute = useRouteMatch(ROUTES.MEMBERSHIP_INVOICES);
  
  useEffect(() => {
    billingData && billingData.idStripe && getMembershipData(billingData.idStripe, billingData.idFacturapi)
    historyRoute && handleChange(1);
    paymentRoute && handleChange(2);
    invoicesRoute && handleChange(3);
  }, []);

  const handleChangeTab = (event, newValue) => {
    switch (newValue) {
      case 1:
        history.push(ROUTES.MEMBERSHIP_HISTORY);
        break;
      case 2:
        history.push(ROUTES.MEMBERSHIP_PAYMETHOD);
        break;
      case 3:
        history.push(ROUTES.MEMBERSHIP_INVOICES);
        break;

      default:
        history.push(ROUTES.MEMBERSHIP);
        break;
    }
    handleChange(newValue);
  };

  const planFree = false;
  const planPlus300 = false;

  return (
    <div className={classes.root}>
      <ScrollToTopOnMount />
      <AppBar className={classes.appBar} position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChangeTab}
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="full width tabs example"
          classes={{
            root: classes.tabs,
            indicator: classes.indicator,
            flexContainer: classes.tabsContainer,
            scrollButtonsDesktop: classes.scrollButtonsDesktop,
          }}
        >
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
            }}
            label="Mi membresía"
            {...a11yProps(0)}
            icon={
              <MembershipIcon
                color={value === 0 ? 'primary' : 'disabled'}
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
              disabled: classes.tabStyleDisabled,
            }}
            disabled={idLawFirm ? true : false}
            label="Historial de pagos"
            {...a11yProps(1)}
            name="politicas"
            icon={
              <HistoryIcon
                color={value === 1 ? 'primary' : 'disabled'}
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
              disabled: classes.tabStyleDisabled,
            }}
            disabled={idLawFirm ? true : false}
            label="Formas de pago"
            {...a11yProps(2)}
            name="politicas"
            icon={
              <PayIcon
                color={value === 2 ? 'primary' : 'disabled'}
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
          <Tab
            classes={{
              root: classes.tabStyle,
              selected: classes.selected,
              textColorPrimary: classes.textColorPrimary,
              wrapper: classes.tabWrapper,
              disabled: classes.tabStyleDisabled,
            }}
            disabled={idLawFirm ? true : false}
            label="Facturas emitidas"
            {...a11yProps(3)}
            name="politicas"
            icon={
              <BillingIcon
                color={value === 3 ? 'primary' : 'disabled'}
                style={{ marginRight: 10, marginBottom: 0 }}
              />
            }
          />
        </Tabs>
      </AppBar>
      <TabPanel className={classes.panel} value={value} index={0}>
        <Features suscription={suscription}  />
      </TabPanel>
      <TabPanel className={classes.panel} value={value} index={1}>
        { ((membershipType === 'Free') || (membershipType === 'Premium Plus' && gift300)) ? (
          <NoMembership
            title="Sin historial de pagos"
            subtitle="Por el momento esta cuenta no tiene historial de pagos"
            button="Conocer membresías"
            direction={
              planPlus300 ?
              ROUTES.PAYMENTS :
              ROUTES.MEMBERSHIPS_LAWYERS  
            }
          />
        ) : (
          <History
            membershipData={membershipData}
            membershipType={membershipType}
          />
        ) }
      </TabPanel>
      <TabPanel className={classes.panel} value={value} index={2}>
         {((membershipType === 'Free') || (membershipType === 'Premium Plus' && gift300)) ? (
          <NoMembership
          title="Sin formas de pago agregadas"
          subtitle="Es necesario contar con una membresía para agregar formas de pago"
          button={membershipType === 'Premium Plus' && gift300 ? 'Ingresar mis datos' : 'Conocer membresías'}
          direction={
            planPlus300 ?
            ROUTES.PAYMENTS :
            ROUTES.MEMBERSHIPS_LAWYERS
          }
        />
          
        ) : (
          <Payment membershipData={membershipData} />
        )}
      </TabPanel>
      <TabPanel className={classes.panel} value={value} index={3}>
        {((membershipType === 'Free') || (membershipType === 'Premium Plus' && gift300)) ? (
          <NoMembership
            title="Aún no has generado facturas"
            subtitle="Es necesario contar con una membresía para facturar"
            button="Conocer membresías"
            direction={ROUTES.MEMBERSHIPS_LAWYERS}
          />
        ) : (
          <Billing membershipData={membershipData} />
        )}
      </TabPanel>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  getMembershipData: (idStripe, idFacturapi) => dispatch(getMembershipData(idStripe,idFacturapi)),
})


const mapStateToProps = (state) => ({
  membershipData: state.authClient.membershipData,
  membershipType: state.authClient.membership.type,
  gift300: state.authClient.membership.gift && state.authClient.membership.gift,
  role: state.authClient.role,
  idLawFirm: state.authClient.idLawFirm,
  billingData: state.billingReducer.billingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(MyMembership);
